module.exports = __webpack_public_path__ + "static/media/LogoHorizontal-White.2ef943b3.jpg";